import type { Neighborhood } from './neighborhoods'

export const SITE_URL = 'https://armandosjunkremoval.com'

export const HOME_KEYWORDS =
  'junk removal San Francisco, junk hauling SF, furniture removal San Francisco, garage cleanout SF, demolition services San Francisco, construction debris removal SF, same day junk removal San Francisco'

export const localBusinessSchema: Record<string, unknown> = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: "Armando's Junk Removal and Hauling",
  url: SITE_URL,
  telephone: '+14157456692',
  email: 'acruzdemo@gmail.com',
  description:
    'Professional junk removal and hauling in San Francisco, CA. Same-day service. Furniture, construction debris, garage cleanouts, demolition. Licensed and insured. Se habla español.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'San Francisco',
    addressRegion: 'CA',
    postalCode: '94112',
    addressCountry: 'US',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 37.7249,
    longitude: -122.4313,
  },
  areaServed: [
    'San Francisco',
    'Mission District',
    'Excelsior District',
    'Bernal Heights',
    'SoMa',
    'Sunset District',
    'Richmond District',
    'Bay Area',
  ],
  priceRange: '$$',
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
      ],
      opens: '07:00',
      closes: '20:00',
    },
  ],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Junk Removal Services San Francisco',
    itemListElement: [
      'Junk Removal San Francisco',
      'Furniture Removal SF',
      'Demolition Services San Francisco',
      'Construction Debris Removal SF',
      'Garage Cleanout San Francisco',
      'Deep Cleaning San Francisco',
    ].map((name) => ({
      '@type': 'Offer',
      itemOffered: { '@type': 'Service', name },
    })),
  },
}

export const faqSchema: Record<string, unknown> = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      question: 'How much does junk removal cost in San Francisco?',
      answer:
        "Junk removal in San Francisco starts at $75 for small loads. We provide free upfront quotes — send us a photo and we'll give you a price in minutes with no hidden fees.",
    },
    {
      question: 'Do you offer same-day junk removal in San Francisco?',
      answer:
        'Yes. We offer same-day and next-day service throughout San Francisco and the Bay Area. Contact us early in the day for best availability.',
    },
    {
      question: 'What types of junk do you remove?',
      answer:
        'We remove furniture, appliances, electronics, construction debris, yard waste, garage junk, and more. Residential and commercial jobs across San Francisco.',
    },
    {
      question: 'Are you licensed and insured?',
      answer:
        "Yes, Armando's Junk Removal and Hauling is fully licensed and insured in San Francisco, CA.",
    },
    {
      question: 'Do you offer services in Spanish?',
      answer:
        'Yes, se habla español. We communicate in Spanish throughout the entire process.',
    },
  ].map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: { '@type': 'Answer', text: item.answer },
  })),
}

export const neighborhoodBusinessSchema = (
  neighborhood: Neighborhood,
): Record<string, unknown> => ({
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: `Armando's Junk Removal — ${neighborhood.name} San Francisco`,
  url: `${SITE_URL}/${neighborhood.slug}`,
  telephone: '+14157456692',
  areaServed: `${neighborhood.name}, San Francisco, CA`,
  serviceType: 'Junk Removal',
  description: `Professional junk removal and hauling in ${neighborhood.name}, San Francisco. Same-day service available.`,
})

export const breadcrumbSchema = (
  neighborhood: Neighborhood,
): Record<string, unknown> => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Services',
      item: `${SITE_URL}/services`,
    },
    {
      '@type': 'ListItem',
      position: 3,
      name: `${neighborhood.name} Junk Removal`,
      item: `${SITE_URL}/${neighborhood.slug}`,
    },
  ],
})
